// home api
import { get, post } from '@web3/base-utils';
import {
  HomeDataParams,
  HomeDataDTO,
  ProjectListParams,
  ProjectListDTO,
  SpotTradeRankParams,
  ProjectTradeInfo,
} from '@/types/home';

export const getHomeData = (params: HomeDataParams = {}) => {
  return get<HomeDataDTO>('/spot/api/web3/content/wsot/home', params);
};

export const getProjectList = (params: ProjectListParams = {}) => {
  return get<{
    projects: ProjectListDTO[];
    remainLotteryCount: number;
  }>('/spot/api/web3/content/wsot/projectList', params);
};

// 现货交易量排行
export const getSpotTradeRank = (
  params: SpotTradeRankParams = { queryType: 0, activityCode: '' }
) => {
  return get<ProjectTradeInfo[]>(
    '/spot/api/web3/content/wsot/projectTradeList',
    params
  );
};
